module.exports = __webpack_public_path__ + "img/tag--tienes.5ac1493d.png";